export const TitleDebtStatus = {
    OPEN: 'OPEN',
    PARTIALLY_PAID: 'PARTIALLY_PAID',
    PAID: 'PAID',
    SUPERSEDED: 'SUPERSEDED',
    CANCELLED: 'CANCELLED',
} as const satisfies Record<string, string>;
export type TitleDebtStatus = typeof TitleDebtStatus[keyof typeof TitleDebtStatus];

export const PaymentType = {
    FINANCIAL: 'FINANCIAL',
    DEBT_CONFESSION: 'DEBT_CONFESSION',
    ASSET_DATION: 'ASSET_DATION',
} as const satisfies Record<string, string>;
export type PaymentType = typeof PaymentType[keyof typeof PaymentType];

export const paymentTypeLabels: Record<string, string> = {
    FINANCIAL: 'Financeiro',
    DEBT_CONFESSION: 'Confissão de Dívida',
    ASSET_DATION: 'Dação de Bens',
};

export const AssetType = {
    VEHICLE: 'VEHICLE',
    MACHINERY: 'MACHINERY',
    REAL_ESTATE: 'REAL_ESTATE',
    PRODUCT: 'PRODUCT',
    GRAIN: 'GRAIN',
} as const satisfies Record<string, string>;
export type AssetType = typeof AssetType[keyof typeof AssetType];

export const assetTypeLabels: Record<string, string> = {
    VEHICLE: 'Veículo',
    MACHINERY: 'Maquinário',
    REAL_ESTATE: 'Imóvel',
    PRODUCT: 'Produto',
    GRAIN: 'Grãos',
};

export interface AssetDationItem {
    asset_type: AssetType;
    description: string;
    estimated_value: number;
    // Vehicle
    plate?: string;
    chassis?: string;
    renavam?: string;
    brand?: string;
    model?: string;
    year?: number;
    // Machinery
    serial_number?: string;
    // Real Estate
    registration_number?: string;
    registry_office?: string;
    total_area?: number;
    built_area?: number;
    land_type?: 'RURAL' | 'URBAN';
    // Product / Grain
    product_type?: string;
    quantity?: number;
    unit?: string;
    storage_location?: string;
}

export const PaymentMethod = {
    PIX: 'PIX',
    TED: 'TED',
    BOLETO: 'BOLETO',
} as const satisfies Record<string, string>;
export type PaymentMethod = typeof PaymentMethod[keyof typeof PaymentMethod];

export const SettlementType = {
    TOTAL: 'TOTAL',
    PARCIAL: 'PARCIAL',
    ATRASO: 'ATRASO',
    ANTECIPADO: 'ANTECIPADO',
} as const satisfies Record<string, string>;
export type SettlementType = typeof SettlementType[keyof typeof SettlementType];

// BankAccount (enum hardcoded) removido — contas de recebimento agora vêm de
// GET /billing/receiving-bank-accounts via <ReceivingBankAccountSelect> (AF-3321).

export const MovementType = {
    TOTAL_PAYMENT: 'TOTAL_PAYMENT',
    PARTIAL_PAYMENT: 'PARTIAL_PAYMENT',
    RENEGOTIATION: 'RENEGOTIATION',
    REVERSAL: 'REVERSAL',
} as const satisfies Record<string, string>;
export type MovementType = typeof MovementType[keyof typeof MovementType];

export const ReversalReason = {
    PAGAMENTO_DUPLICADO: 'Pagamento duplicado',
    VALOR_INCORRETO: 'Valor incorreto',
    OPERACAO_CANCELADA: 'Operação cancelada',
    ERRO_SISTEMA: 'Erro de sistema',
} as const satisfies Record<string, string>;
export type ReversalReason = typeof ReversalReason[keyof typeof ReversalReason];

export const statusColors: Record<string, 'blue' | 'green' | 'red' | 'orange' | 'gray' | 'yellow' | 'purple'> = {
    OPEN: 'yellow',
    PAID: 'green',
    PARTIALLY_PAID: 'orange',
    SUPERSEDED: 'gray',
    CANCELLED: 'red',
};

export const statusLabels: Record<string, string> = {
    OPEN: 'Em aberto',
    PARTIALLY_PAID: 'Parcial',
    PAID: 'Pago',
    SUPERSEDED: 'Renegociado',
    CANCELLED: 'Cancelado',
};

export const movementTypeLabels: Record<string, string> = {
    TOTAL_PAYMENT: 'Pagamento Total',
    PARTIAL_PAYMENT: 'Pagamento Parcial',
    RENEGOTIATION: 'Renegociação',
    REVERSAL: 'Estorno',
};

export const settlementTypeLabels: Record<number, string> = {
    1: 'Total',
    2: 'Parcial',
    3: 'Em Atraso',
    4: 'Antecipado',
};
